import React, { Component } from "react";
import { ButtonToolbar, Table, Grid } from 'react-bootstrap';

import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { LoadingSpinner } from '../../LoadingSpinner';
import { ComparisonHelper } from '../../helpers/ComparisonHelper';
import { TableButton } from '../../TableButton';

export class LanesActiveList extends Component {
    sortLanes(a, b) {
        let aName = a.name;
        let bName = b.name;

        if ("object" === typeof aName) {
            aName = undefined !== aName.left ? aName.left : aName.right;
        }

        if ("object" === typeof bName) {
            bName = undefined !== bName.left ? bName.left : bName.right;
        }

        return aName !== bName ? aName < bName ? -1 : 1 : 0;
    }

    // -----------------------

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    render() {
        const { lanes, isLoading, currentPage,
            elementsPerPage, isComparing, filter } = this.props;

        let lanesFiltered;
        if (isComparing) {
            const { draftLanes } = this.props;
            lanesFiltered = SearchHelper.search({
                filter: filter,
                data: ComparisonHelper.compare(
                    lanes,
                    draftLanes || [],
                    {
                        match: [{ left: "name", right: "name" }],
                        fields: [{ left: "name", right: "name" }],
                    }),
                fields: ["name", "name.left", "name.right"],
            });
        }
        else {
            lanesFiltered = SearchHelper.search({
                filter: filter,
                data: lanes,
                fields: ["name"],
            });
        }

        const totalPages = PaginationHelper.getTotalPages(lanesFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const lanesToRender = lanesFiltered.sort((a, b) => this.sortLanes(a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Descrição</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className={isLoading ? "overlay" : ""}>
                            {
                                lanesToRender.map((lane, idx) =>
                                    <tr key={`lane-${idx}`} className={ComparisonHelper.getRowClass(lane.name)}>
                                        <td>{ComparisonHelper.renderProperty(lane.name)}</td>
                                        <td>{ComparisonHelper.renderProperty(lane.description)}</td>
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(lane)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(lane)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <PaginationBuilder
                        currentPage={activePage}
                        elementsPerPage={elementsPerPage}
                        dataLength={lanesFiltered.length}
                        onChangePage={(a) => this.props.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.props.onChangeElementsPerPage(a)} />

                    {this.renderLoading(isLoading)}
                </div>
            </Grid>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/datamanager/lanes/LanesActiveList.js